import React, { useEffect, useState, useMemo } from "react";
import { Translator } from "./translator";

const Cookies = () => {
  const { translateText, lang } = Translator();

  // ===== Fixed IT / EN / FR text =====
  const baseTextByLang = useMemo(
    () => ({
      it: {
        title: "Informativa sui Cookie",
        updated: "Ultimo aggiornamento: 10 Settembre 2025",
        intro:
          "Questa Informativa sui Cookie spiega come Te.C.H-e (di proprietà e gestito da Emozionarti Srl) utilizza i cookie e tecnologie simili per riconoscerti quando visiti il nostro sito web o utilizzi i nostri servizi. Spiega cosa sono queste tecnologie, perché le usiamo e i tuoi diritti di controllarne l'utilizzo.",

        section1: "Cosa sono i Cookie?",
        section1Text:
          "I cookie sono piccoli file di dati inseriti sul tuo dispositivo quando visiti un sito web. Ci aiutano a migliorare la tua esperienza ricordando le tue preferenze, abilitando funzionalità e raccogliendo informazioni sulle tue interazioni con il nostro sito.",

        section2: "Tipi di Cookie che Utilizziamo",
        section2Text:
          "Utilizziamo i seguenti tipi di cookie sui Servizi Te.C.H-e:",
        cookie1:
          "Cookie Essenziali: Necessari per il funzionamento del nostro sito, come l'abilitazione di login sicuri e la navigazione. Questi cookie non possono essere disabilitati.",
        cookie2:
          "Cookie di Prestazione: Raccolgono informazioni su come gli utenti interagiscono con il nostro sito (ad es. pagine visitate e tempo trascorso) per migliorare la funzionalità.",
        cookie3:
          "Cookie di Funzionalità: Ricordano le tue preferenze (ad es. lingua o regione) per personalizzare la tua esperienza.",
        cookie4:
          "Cookie di Targeting/Pubblicità: Forniscono annunci pertinenti in base alle tue abitudini di navigazione.",
        cookie5:
          "Cookie di Misurazione (Google Analytics 4): Raccolgono dati aggregati sulle visite e l’utilizzo del sito per migliorare servizi e contenuti.",
        cookie6:
          "Cookie Pubblicitari (Google AdSense): Utilizzati per mostrare annunci pertinenti e misurare le prestazioni delle campagne.",

        section3: "Come Utilizziamo i Cookie",
        section3Intro: "Utilizziamo i cookie per:",
        use1:
          "Abilitare le funzionalità essenziali del sito e servizi sicuri.",
        use2: "Personalizzare contenuti e raccomandazioni.",
        use3:
          "Analizzare le prestazioni del sito e il comportamento degli utenti per migliorare la nostra piattaforma.",
        use4:
          "Fornire pubblicità mirata e misurarne l'efficacia.",

        section4: "Cookie di Terze Parti",
        section4Text:
          "Potremmo consentire a fornitori di servizi terzi di inserire cookie sul tuo dispositivo per fornire servizi come analisi, pubblicità o integrazione con i social media. Queste terze parti possono utilizzare le informazioni raccolte tramite i cookie in conformità alle proprie politiche sulla privacy.",

        section5: "Le Tue Scelte e la Gestione dei Cookie",
        section5Intro:
          "Hai il diritto di accettare o rifiutare i cookie. Puoi gestire le tue preferenze nei seguenti modi:",
        choice1:
          "Impostazioni del Browser: La maggior parte dei browser ti consente di controllare o eliminare i cookie tramite le impostazioni. Consulta il menu di aiuto del tuo browser per istruzioni.",
        choice2:
          "Banner dei Cookie: Utilizza il banner delle preferenze sui cookie presente sul nostro sito per gestire il tuo consenso.",
        choice3:
          'Do Not Track: Abilita l\'opzione "Do Not Track" nel tuo browser, se disponibile.',
        section5Note:
          "Tieni presente che disabilitare i cookie potrebbe influire sulla funzionalità dei Servizi Te.C.H-e e alcune funzionalità potrebbero non funzionare come previsto.",

        section6: "Aggiornamenti a Questa Informativa sui Cookie",
        section6Text:
          "Potremmo aggiornare periodicamente questa Informativa sui Cookie per riflettere modifiche alle nostre pratiche o per motivi legali. La data “Ultimo aggiornamento” in alto indica la revisione più recente.",

        section7: "Contattaci",
        section7Text:
          "Se hai domande o dubbi sull'uso dei cookie, contattaci:",
        footer: "© {year} Te.C.H-e – Tutti i diritti riservati.",

        text1: "Emozionarti Srl",
        text2: "Via Giuseppe Verdi 46",
        text3: "80038 Pomigliano d'Arco, Italia",
        text4: "Telefono: +39 081 424 4274",

        section8: "Servizi di terze parti che utilizziamo",
        section8Text:
          "Sul sito techetour.it utilizziamo i seguenti servizi che impostano cookie/tecnologie simili:",
        third1:
          "Google Analytics 4 (GA4): misurazione dell’audience e analisi dell’utilizzo del sito. I dati sono aggregati e non includono informazioni di identificazione diretta.",
        third2:
          "Google AdSense: erogazione di annunci pubblicitari e misurazione delle performance degli annunci.",
        third3:
          "Google Tag (gtag.js): strumento tecnico per inviare eventi a GA4/AdSense nel rispetto del consenso.",
        third4:
          "Stripe (pagamenti): cookie tecnici necessari alla prevenzione frodi e al completamento sicuro dei pagamenti.",

        section9: "Consenso e gestione preferenze (Consent Mode)",
        section9Text1:
          "Per conformità con la normativa UE, mostriamo un banner di preferenze. Fino al consenso, i cookie per analytics e pubblicità sono disattivati (Consent Mode: denied).",
        section9Text2:
          "Puoi modificare le preferenze in qualsiasi momento tramite il banner o le impostazioni del browser.",
        section9Text3:
          "Quando acconsenti, abilitiamo soltanto le categorie selezionate (ad esempio: analytics, advertising).",

        section10: "Come disattivare Google Analytics / Pubblicità",
        section10Text1:
          "Puoi rifiutare il consenso dal banner o configurare il browser per bloccare i cookie.",
        section10Text2:
          "La disattivazione dei cookie non essenziali non pregiudica la navigazione, ma alcune funzionalità potrebbero risultare limitate.",
      },

      en: {
        title: "Cookie Policy",
        updated: "Last updated: 10 September 2025",
        intro:
          "This Cookie Policy explains how Te.C.H-e (owned and operated by Emozionarti Srl) uses cookies and similar technologies to recognize you when you visit our website or use our services. It explains what these technologies are, why we use them, and your rights to control their use.",

        section1: "What Are Cookies?",
        section1Text:
          "Cookies are small data files placed on your device when you visit a website. They help us improve your experience by remembering your preferences, enabling features, and collecting information about how you interact with our site.",

        section2: "Types of Cookies We Use",
        section2Text:
          "We use the following types of cookies on the Te.C.H-e Services:",
        cookie1:
          "Essential Cookies: Necessary for the operation of our site, such as enabling secure logins and navigation. These cookies cannot be disabled.",
        cookie2:
          "Performance Cookies: Collect information about how users interact with our site (e.g., pages visited and time spent) to help us improve functionality.",
        cookie3:
          "Functionality Cookies: Remember your preferences (e.g., language or region) to personalize your experience.",
        cookie4:
          "Targeting/Advertising Cookies: Deliver relevant advertisements based on your browsing habits.",
        cookie5:
          "Measurement Cookies (Google Analytics 4): Collect aggregated data about visits and usage of the site to improve our services and content.",
        cookie6:
          "Advertising Cookies (Google AdSense): Used to display relevant ads and measure the performance of advertising campaigns.",

        section3: "How We Use Cookies",
        section3Intro: "We use cookies to:",
        use1:
          "Enable essential site features and secure services.",
        use2: "Personalize content and recommendations.",
        use3:
          "Analyze site performance and user behavior to improve our platform.",
        use4:
          "Provide targeted advertising and measure its effectiveness.",

        section4: "Third-Party Cookies",
        section4Text:
          "We may allow third-party service providers to place cookies on your device to deliver services such as analytics, advertising, or social media integration. These third parties may use the information collected through cookies in accordance with their own privacy policies.",

        section5: "Your Choices and Cookie Management",
        section5Intro:
          "You have the right to accept or reject cookies. You can manage your preferences in the following ways:",
        choice1:
          "Browser Settings: Most browsers allow you to control or delete cookies through their settings. Refer to your browser’s help menu for instructions.",
        choice2:
          "Cookie Banner: Use the cookie preference banner on our site to manage your consent.",
        choice3:
          'Do Not Track: Enable the "Do Not Track" option in your browser, where available.',
        section5Note:
          "Please note that disabling cookies may affect the functionality of the Te.C.H-e Services, and some features may not work as intended.",

        section6: "Updates to This Cookie Policy",
        section6Text:
          "We may update this Cookie Policy from time to time to reflect changes in our practices or for legal reasons. The “Last updated” date at the top indicates the most recent revision.",

        section7: "Contact Us",
        section7Text:
          "If you have any questions or concerns about our use of cookies, please contact us:",
        footer: "© {year} Te.C.H-e – All rights reserved.",

        text1: "Emozionarti Srl",
        text2: "Via Giuseppe Verdi 46",
        text3: "80038 Pomigliano d'Arco, Italy",
        text4: "Phone: +39 081 424 4274",

        section8: "Third-Party Services We Use",
        section8Text:
          "On techetour.it we use the following services that set cookies or similar technologies:",
        third1:
          "Google Analytics 4 (GA4): audience measurement and analysis of site usage. Data is aggregated and does not include directly identifying information.",
        third2:
          "Google AdSense: delivery of advertising and measurement of ad performance.",
        third3:
          "Google Tag (gtag.js): technical tool used to send events to GA4/AdSense in line with your consent preferences.",
        third4:
          "Stripe (payments): technical cookies necessary for fraud prevention and for securely completing payments.",

        section9: "Consent and Preference Management (Consent Mode)",
        section9Text1:
          "To comply with EU regulations, we display a preference banner. Until consent is given, analytics and advertising cookies are disabled (Consent Mode: denied).",
        section9Text2:
          "You can change your preferences at any time via the banner or your browser settings.",
        section9Text3:
          "When you give consent, we enable only the categories you have selected (for example: analytics, advertising).",

        section10: "How to Disable Google Analytics / Advertising",
        section10Text1:
          "You can refuse consent via the banner or configure your browser to block cookies.",
        section10Text2:
          "Disabling non-essential cookies does not prevent you from browsing the site, but some features may be limited.",
      },

      fr: {
        title: "Politique relative aux cookies",
        updated: "Dernière mise à jour : 10 septembre 2025",
        intro:
          "La présente Politique relative aux cookies explique comment Te.C.H-e (détenu et exploité par Emozionarti Srl) utilise des cookies et des technologies similaires pour vous reconnaître lorsque vous visitez notre site web ou utilisez nos services. Elle explique ce que sont ces technologies, pourquoi nous les utilisons et quels sont vos droits pour en contrôler l’utilisation.",

        section1: "Que sont les cookies ?",
        section1Text:
          "Les cookies sont de petits fichiers de données placés sur votre appareil lorsque vous visitez un site web. Ils nous aident à améliorer votre expérience en mémorisant vos préférences, en activant certaines fonctionnalités et en collectant des informations sur la manière dont vous interagissez avec notre site.",

        section2: "Types de cookies que nous utilisons",
        section2Text:
          "Nous utilisons les types de cookies suivants sur les Services Te.C.H-e :",
        cookie1:
          "Cookies essentiels : nécessaires au fonctionnement de notre site, par exemple pour permettre des connexions sécurisées et la navigation. Ces cookies ne peuvent pas être désactivés.",
        cookie2:
          "Cookies de performance : recueillent des informations sur la façon dont les utilisateurs interagissent avec notre site (par exemple, pages visitées et temps passé) afin de nous aider à améliorer ses fonctionnalités.",
        cookie3:
          "Cookies de fonctionnalité : mémorisent vos préférences (par exemple la langue ou la région) pour personnaliser votre expérience.",
        cookie4:
          "Cookies de ciblage / publicité : diffusent des annonces pertinentes en fonction de vos habitudes de navigation.",
        cookie5:
          "Cookies de mesure (Google Analytics 4) : collectent des données agrégées sur les visites et l’utilisation du site afin d’améliorer nos services et contenus.",
        cookie6:
          "Cookies publicitaires (Google AdSense) : utilisés pour afficher des annonces pertinentes et mesurer les performances des campagnes publicitaires.",

        section3: "Comment nous utilisons les cookies",
        section3Intro: "Nous utilisons les cookies pour :",
        use1:
          "Activer les fonctionnalités essentielles du site et assurer des services sécurisés.",
        use2: "Personnaliser le contenu et les recommandations.",
        use3:
          "Analyser les performances du site et le comportement des utilisateurs afin d’améliorer notre plateforme.",
        use4:
          "Fournir une publicité ciblée et en mesurer l’efficacité.",

        section4: "Cookies de tiers",
        section4Text:
          "Nous pouvons autoriser des prestataires de services tiers à placer des cookies sur votre appareil afin de fournir des services tels que l’analyse, la publicité ou l’intégration avec les réseaux sociaux. Ces tiers peuvent utiliser les informations collectées via les cookies conformément à leurs propres politiques de confidentialité.",

        section5: "Vos choix et la gestion des cookies",
        section5Intro:
          "Vous avez le droit d’accepter ou de refuser les cookies. Vous pouvez gérer vos préférences de la manière suivante :",
        choice1:
          "Paramètres du navigateur : la plupart des navigateurs vous permettent de contrôler ou de supprimer les cookies via leurs paramètres. Consultez le menu d’aide de votre navigateur pour plus d’informations.",
        choice2:
          "Bannière de cookies : utilisez la bannière de préférences en matière de cookies sur notre site pour gérer votre consentement.",
        choice3:
          'Do Not Track : activez l’option « Do Not Track » dans votre navigateur, lorsque celle-ci est disponible.',
        section5Note:
          "Veuillez noter que la désactivation des cookies peut affecter le fonctionnement des Services Te.C.H-e et que certaines fonctionnalités peuvent ne pas fonctionner comme prévu.",

        section6: "Mises à jour de la présente politique relative aux cookies",
        section6Text:
          "Nous pouvons mettre à jour périodiquement la présente Politique relative aux cookies afin de refléter des changements dans nos pratiques ou pour des raisons juridiques. La date « Dernière mise à jour » indiquée ci-dessus reflète la révision la plus récente.",

        section7: "Nous contacter",
        section7Text:
          "Si vous avez des questions ou des préoccupations concernant l’utilisation des cookies, vous pouvez nous contacter :",
        footer:
          "© {year} Te.C.H-e – Tous droits réservés.",

        text1: "Emozionarti Srl",
        text2: "Via Giuseppe Verdi 46",
        text3: "80038 Pomigliano d'Arco, Italie",
        text4: "Téléphone : +39 081 424 4274",

        section8: "Services tiers que nous utilisons",
        section8Text:
          "Sur le site techetour.it, nous utilisons les services suivants qui installent des cookies ou des technologies similaires :",
        third1:
          "Google Analytics 4 (GA4) : mesure d’audience et analyse de l’utilisation du site. Les données sont agrégées et ne contiennent pas d’informations d’identification directe.",
        third2:
          "Google AdSense : diffusion de publicités et mesure des performances des annonces.",
        third3:
          "Google Tag (gtag.js) : outil technique permettant d’envoyer des événements à GA4/AdSense dans le respect de vos préférences de consentement.",
        third4:
          "Stripe (paiements) : cookies techniques nécessaires à la prévention des fraudes et à l’exécution sécurisée des paiements.",

        section9: "Consentement et gestion des préférences (Consent Mode)",
        section9Text1:
          "Pour nous conformer à la réglementation européenne, nous affichons une bannière de préférences. Tant que vous n’avez pas donné votre consentement, les cookies d’analyse et de publicité sont désactivés (Consent Mode : denied).",
        section9Text2:
          "Vous pouvez modifier vos préférences à tout moment via la bannière ou les paramètres de votre navigateur.",
        section9Text3:
          "Lorsque vous donnez votre consentement, nous n’activons que les catégories que vous avez sélectionnées (par exemple : analytics, advertising).",

        section10: "Comment désactiver Google Analytics / Publicité",
        section10Text1:
          "Vous pouvez refuser votre consentement via la bannière ou configurer votre navigateur pour bloquer les cookies.",
        section10Text2:
          "La désactivation des cookies non essentiels ne vous empêche pas de naviguer sur le site, mais certaines fonctionnalités peuvent être limitées.",
      },
    }),
    []
  );

  const [text, setText] = useState(
    baseTextByLang[lang] || baseTextByLang.en
  );

  // ===== i18n behaviour: IT/EN/FR fixed, other languages via Translator =====
  useEffect(() => {
    // For Italian, English, French → use fixed text
    if (lang === "it" || lang === "en" || lang === "fr") {
      setText(baseTextByLang[lang] || baseTextByLang.en);
      return;
    }

    // For all other languages → translate from Italian base
    let cancelled = false;

    const translateAll = async () => {
      try {
        const source = baseTextByLang.it;
        const entries = Object.entries(source);
        const translatedEntries = await Promise.all(
          entries.map(async ([key, value]) => {
            const out = await translateText(value);
            return [key, out || value];
          })
        );
        if (!cancelled) {
          setText(Object.fromEntries(translatedEntries));
        }
      } catch {
        if (!cancelled) {
          setText(baseTextByLang.en);
        }
      }
    };

    translateAll();
    return () => {
      cancelled = true;
    };
  }, [lang, translateText, baseTextByLang]);

  return (
    <div className="max-w-4xl mx-auto px-4 py-10 font-sans text-gray-800">
      <h1 className="text-3xl md:text-4xl font-bold text-center mb-4">
        {text.title}
      </h1>
      <p className="text-sm text-gray-500 text-center mb-6">
        {text.updated}
      </p>

      <p className="mb-6">{text.intro}</p>

      <Section className="text-black" title={text.section1}>
        <p className="text-black">{text.section1Text}</p>
      </Section>

      <Section className="text-black" title={text.section2}>
        <p className="mb-4">{text.section2Text}</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>{text.cookie1}</li>
          <li>{text.cookie2}</li>
          <li>{text.cookie3}</li>
          <li>{text.cookie4}</li>
          <li>{text.cookie5}</li>
          <li>{text.cookie6}</li>
        </ul>
      </Section>

      <Section title={text.section3}>
        <p className="mb-4">{text.section3Intro}</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>{text.use1}</li>
          <li>{text.use2}</li>
          <li>{text.use3}</li>
          <li>{text.use4}</li>
        </ul>
      </Section>

      <Section title={text.section4}>
        <p>{text.section4Text}</p>
      </Section>

      <Section title={text.section5}>
        <p className="mb-4">{text.section5Intro}</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>{text.choice1}</li>
          <li>{text.choice2}</li>
          <li>{text.choice3}</li>
        </ul>
        <p className="mt-4">{text.section5Note}</p>
      </Section>

      <Section title={text.section6}>
        <p>{text.section6Text}</p>
      </Section>

      <Section title={text.section8}>
        <p className="mb-4">{text.section8Text}</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>{text.third1}</li>
          <li>{text.third2}</li>
          <li>{text.third3}</li>
          <li>{text.third4}</li>
        </ul>
      </Section>

      <Section title={text.section9}>
        <p className="mb-3">{text.section9Text1}</p>
        <p className="mb-3">{text.section9Text2}</p>
        <p>{text.section9Text3}</p>
      </Section>

      <Section title={text.section10}>
        <p className="mb-3">{text.section10Text1}</p>
        <p>{text.section10Text2}</p>
      </Section>

      <Section title={text.section7}>
        <p className="mb-4">{text.section7Text}</p>
        <div className="bg-gray-100 border border-gray-300 p-4 rounded-lg">
          <h3 className="font-semibold mb-1">{text.text1}</h3>
          <p className="text-sm">
            {text.text2} <br />
            {text.text3} <br />
            <a
              href="mailto:emozionartisrl@gmail.com"
              className="text-blue-600 hover:underline"
            >
              emozionartisrl@gmail.com
            </a>
            <br />
            {text.text4}
          </p>
        </div>
      </Section>

      <footer className="text-sm text-center text-gray-500 mt-10">
        {text.footer.replace("{year}", new Date().getFullYear())}
      </footer>
    </div>
  );
};

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="text-black text-2xl font-semibold mb-3">
      {title}
    </h2>
    {children}
  </section>
);

export default Cookies;
